import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { CCMCSearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        CCMCSearchBarComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,

        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        CCMCSearchBarComponent
    ]
})
export class CCMCSearchBarModule {
}
